import React from 'react';
import './Skeleton.css';

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  className?: string;
  style?: React.CSSProperties;
}

const Skeleton: React.FC<SkeletonProps> = ({
  width = '100%',
  height = '1rem',
  borderRadius = '6px',
  className = '',
  style,
}) => (
  <div
    className={`skeleton-shimmer ${className}`}
    style={{ width, height, borderRadius, ...style }}
    aria-hidden="true"
  />
);

export default Skeleton;

export const SkeletonText: React.FC<{ lines?: number; className?: string }> = ({
  lines = 3,
  className = '',
}) => (
  <div className={`skeleton-text ${className}`} aria-hidden="true">
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton
        key={i}
        height="0.9rem"
        width={i === lines - 1 ? '70%' : '100%'}
        style={{ marginBottom: i < lines - 1 ? '0.6rem' : 0 }}
      />
    ))}
  </div>
);

export const SkeletonCard: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`skeleton-card ${className}`} aria-hidden="true">
    <div className="skeleton-card-header">
      <Skeleton width="2.5rem" height="2.5rem" borderRadius="50%" />
      <div style={{ flex: 1 }}>
        <Skeleton width="40%" height="1.1rem" style={{ marginBottom: '0.5rem' }} />
        <Skeleton width="60%" height="0.8rem" />
      </div>
      <Skeleton width="5rem" height="1.5rem" borderRadius="20px" />
    </div>
    <div className="skeleton-card-body">
      <Skeleton width="30%" height="0.8rem" style={{ marginBottom: '0.5rem' }} />
      <SkeletonText lines={2} />
    </div>
    <div className="skeleton-card-footer">
      <Skeleton width="6rem" height="2rem" borderRadius="8px" />
      <Skeleton width="6rem" height="2rem" borderRadius="8px" />
      <Skeleton width="6rem" height="2rem" borderRadius="8px" />
    </div>
  </div>
);
